import { forwardRef } from 'react';

import {
  TextareaAutosize,
  TextareaAutosizeProps,
  Theme,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      border: 'none',
      outline: 'none',
      backgroundColor: 'transparent',
      color: 'inherit',
      padding: 0,
      flex: 1,
      resize: 'none',

      // if we spread theme.typography.body1 we get a type error
      fontFamily: theme.typography.body1.fontFamily,
      fontSize: theme.typography.body1.fontSize,
      lineHeight: theme.typography.body1.lineHeight,
    },
  });

export interface InputGroupTextareaProps
  extends Omit<TextareaAutosizeProps, 'classes'>,
    WithStyles<typeof styles> {}

const InputGroupTextArea = forwardRef<
  HTMLTextAreaElement,
  InputGroupTextareaProps
>(({ className, classes, ...rest }, ref) => {
  return (
    <TextareaAutosize
      ref={ref}
      className={classNames(classes.root, className)}
      data-slot="input"
      {...rest}
    />
  );
});

InputGroupTextArea.displayName = 'InputGroup.Textarea';

export default withStyles(styles)(InputGroupTextArea);
